import { Injectable } from '@angular/core';
import { AuthUser } from '../interface/auth.user';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SurveyAnswerService {
  authUserId: string;
  selectedUserID: string = '';
  constructor(private store: AngularFirestore, private afAuth: AngularFireAuth) {
    this.getAuthUser(() => {});
  }

  public getAuthUser(cb: any): void {
    this.afAuth.authState.subscribe(
      (authUser: AuthUser) => {
        if (authUser) {
          this.authUserId = authUser.uid;
          cb();
        }
      },
      () => {
        this.authUserId = null;
      }
    );
  }

  public setUserId(id: string): Observable<any> {
    this.selectedUserID = id;
    localStorage.setItem('userId', JSON.stringify(this.selectedUserID));
    return of(this.selectedUserID);
  }

  public getUserId(): string {
    this.selectedUserID = JSON.parse(localStorage.getItem('userId'));
    return this.selectedUserID;
  }

  public getUserSurveyName(id: string) {
    return this.store.collection<any>('surveys').doc(id).valueChanges();
  }

  public getUserSurveyAnswers(id: string, userId: string, surveyUUID: string) {
    return this.store
      .collection<any>('survey-answers')
      .doc(userId)
      .collection('survey')
      .doc(surveyUUID)
      .collection('answers')
      .doc(id)
      .valueChanges();
  }

  public getUserSurveyList(id: string) {
    return this.store.collection<any>('survey-answers').doc(id).collection('survey').valueChanges();
  }

  public getUsersList() {
    const ref = this.store.collection('user');
    return ref.valueChanges({ idField: 'id' });
  }
}
